/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import R from 'ramda'
import autoBind from 'react-autobind'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { Card, Subheader, Checkbox, FontIcon } from 'material-ui'

import { DatePicker, TimePicker, TextField } from 'generic/form'

import * as actions from 'actions/ApplicantPrestation'
import * as constants from 'constants/Prestation'

class PrestationValidation extends React.Component {

  constructor(props) {
    super(props)
    autoBind(this)
  }

  handleSetOrderedDateRef(field) {
    this.orderedDatePicker = field || null
  }

  handleSetDeliveredDateRef(field) {
    this.deliveredDatePicker = field || null
  }

  handleSetOrderedStartRef(field) {
    this.orderedStartTimePicker = field || null
  }

  handleSetDeliveredStartRef(field) {
    this.deliveredStartTimePicker = field || null
  }

  handleSetOrderedEndRef(field) {
    this.orderedEndTimePicker = field || null
  }

  handleSetDeliveredEndRef(field) {
    this.deliveredEndTimePicker = field || null
  }

  handleChange(event, value) {
    this.props.handlePrestationChange(event.target.name, value)
  }

  handleInvoiceOnlyAdditionalServicesChange(event, value) {
    const prestation = {
      ...this.props.prestation,
      [event.target.name]: value,
      interpreter_delay: 0,
      happened: false,
      interpreter_travelled: false,
      additional_services: value ?
        this.props.prestation.additional_services
        : 0,
      meta: {
        ...this.props.prestation.meta,
        fields: {
          ...this.props.prestation.meta.fields,
          additional_services: {
            ...this.props.prestation.meta.fields.additional_services,
            mandatory: value
          }
        }
      }
    }

    this.props.handleFormChange('prestation', prestation)
  }

  handleChangePrestationNotHappened(event, value) {
    const prestation = {
      ...this.props.prestation,
      [event.target.name]: value,
      interpreter_delay: 0
    }

    this.props.handleFormChange('prestation', prestation)
  }

  handleBillingChange(event, value) {
    this.props.handlePrestationChange(event.target.name, value)

    const prestation = {
      ...this.props.prestation,
      billing: value
    }

    return actions.postPrestationAdmin(prestation)
  }

  render() {
    const prestation = this.props.prestation
    const meta = prestation && prestation.meta ? prestation.meta.fields : {}

    const orderedDate = prestation &&
                        prestation.ordered_date &&
                        prestation.ordered_date.length === 10
                          ? moment(prestation.ordered_date, 'YYYY-MM-DD').format('DD.MM.YYYY')
                          : prestation && prestation.ordered_date
                            ? prestation.ordered_date
                            : undefined

    const orderedStartTime = prestation &&
                             prestation.ordered_start_time &&
                             prestation.ordered_start_time.length === 5
                               ? moment(prestation.ordered_start_time, 'HH:mm').format('HH:mm')
                               : prestation && prestation.ordered_start_time
                                 ? prestation.ordered_start_time
                                 : undefined

    const orderedEndTime = prestation &&
                           prestation.ordered_end_time &&
                           prestation.ordered_end_time.length === 5
                             ? moment(prestation.ordered_end_time, 'HH:mm').format('HH:mm')
                             : prestation && prestation.ordered_end_time
                               ? prestation.ordered_end_time
                               : undefined

    const deliveredDate = prestation &&
                          prestation.delivered_date &&
                          prestation.delivered_date.length === 10
                            ? moment(prestation.delivered_date, 'YYYY-MM-DD').format('DD.MM.YYYY')
                            : prestation && prestation.delivered_date
                              ? prestation.delivered_date
                              : undefined

    const deliveredStartTime = prestation &&
                               prestation.delivered_start_time &&
                               prestation.delivered_start_time.length === 5
                                 ? moment(prestation.delivered_start_time, 'HH:mm').format('HH:mm')
                                 : prestation && prestation.delivered_start_time
                                   ? prestation.delivered_start_time
                                   : undefined

    const deliveredEndTime = prestation &&
                             prestation.delivered_end_time &&
                             prestation.delivered_end_time.length === 5
                               ? moment(prestation.delivered_end_time, 'HH:mm').format('HH:mm')
                               : prestation && prestation.delivered_end_time
                                 ? prestation.delivered_end_time
                                 : undefined

    return(
      <Card
        style={styles.card}
      >
        <Subheader style={{textAlign: 'center'}}>
          {this.props.intl.formatMessage(constants.messages.PRESTATION_VALIDATION)}
        </Subheader>

        <div className='row'>
          <div className='col-xs-12'>
            <h5 style={styles.title}>
              {this.props.intl.formatMessage(constants.messages.STEP_THREE_ORDERED_DATETIME)}
            </h5>
          </div>

          <div className='col-md-12 col-xs-12'>
            <TextField
              name='ordered_date'
              meta={meta.ordered_start_time}
              disabled={!!prestation.happened && !!this.props.prestation.delivered_start_time}
              value={orderedDate}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.DATE_LABEL)}
              onChange={(event, value) => this.props.handleDateFormatChange(event.target.name, value)}
              mask='99.99.9999'
              style={styles.fontText}
              errorText={this.props.errors ? this.props.errors.ordered_date : undefined}
              placeholderMandatory={true}
            />

            <DatePicker
              name='ordered_date'
              divStyle={{display: 'none'}}
              locale={this.props.intl.locale}
              onChange={(event, value) => this.props.handleDateChange(event.target.name, value)}
              getField={this.handleSetOrderedDateRef}
            />

            {
              !prestation.happened ||
              !prestation.delivered_start_time
                ? <FontIcon
                  onClick={() => this.orderedDatePicker.focus()}
                  className='material-icons'
                  style={{
                    margin: '20px 5px 0 0',
                    top: 190,
                    right: '78.5%',
                    position: 'absolute',
                    cursor: 'pointer'
                  }}
                >today
                </FontIcon>
                : undefined
            }
          </div>
        </div>

        {
          !prestation.invoice_only_additional_services
            ? <div className='row'>
              <div className='col-md-6 col-xs-12'>
                <TextField
                  name='ordered_start_time'
                  meta={meta.ordered_start_time}
                  disabled={!!prestation.happened && !!this.props.prestation.delivered_start_time}
                  value={orderedStartTime}
                  floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_START_LABEL)}
                  onChange={(event, value) => this.props.handleTimeFormatChange(event.target.name, value)}
                  mask='99:99'
                  style={styles.fontText}
                  errorText={this.props.errors ? this.props.errors.ordered_start_time : undefined}
                  placeholderMandatory={true}
                />
                <TimePicker
                  name='ordered_start_time'
                  divStyle={{display: 'none'}}
                  locale={this.props.intl.locale}
                  onChange={(event, value) => this.props.handleTimeChange(event.target.name, value)}
                  getField={this.handleSetOrderedStartRef}
                />

                {
                  !prestation.happened ||
                  !prestation.delivered_start_time
                    ? <FontIcon
                      onClick={() => this.orderedStartTimePicker.focus()}
                      className='material-icons'
                      style={{
                        margin: '20px 5px 0 0',
                        top: 259,
                        right: '89%',
                        position: 'absolute',
                        cursor: 'pointer'
                      }}
                    >schedule
                    </FontIcon>
                    : undefined
                }
              </div>

              <div className='col-md-6 col-xs-12'>
                <TextField
                  name='ordered_end_time'
                  meta={meta.ordered_end_time}
                  disabled={!!prestation.happened && !!this.props.prestation.delivered_start_time}
                  value={orderedEndTime}
                  floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_END_LABEL)}
                  onChange={(event, value) => this.props.handleTimeFormatChange(event.target.name, value)}
                  mask='99:99'
                  style={styles.fontText}
                  errorText={this.props.errors ? this.props.errors.ordered_end_time : undefined}
                  placeholderMandatory={true}
                />

                <TimePicker
                  name='ordered_end_time'
                  divStyle={{display: 'none'}}
                  locale={this.props.intl.locale}
                  onChange={(event, value) => this.props.handleTimeChange(event.target.name, value)}
                  getField={this.handleSetOrderedEndRef}
                />

                {
                  !prestation.happened ||
                  !prestation.delivered_start_time
                    ? <FontIcon
                      onClick={() => this.orderedEndTimePicker.focus()}
                      className='material-icons'
                      style={{
                        margin: '20px 5px 0 0',
                        top: 259,
                        right: '78.5%',
                        position: 'absolute',
                        cursor: 'pointer'
                      }}
                    >schedule
                    </FontIcon>
                    : undefined
                }
              </div>
            </div>
            : undefined
        }

        {
          prestation.delivered_start_time ||
          prestation.delivered_end_time
            ? <React.Fragment>
              <div className='row'>
                <div className='col-xs-12'>
                  <h5 style={styles.title}>
                    {this.props.intl.formatMessage(constants.messages.STEP_THREE_DELIVERED_DATETIME)}
                  </h5>
                </div>

                <div className='col-md-12 col-xs-12'>
                  <TextField
                    name='delivered_date'
                    disabled={!prestation.happened}
                    meta={meta.delivered_start_time}
                    value={deliveredDate}
                    floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_DATE_LABEL)}
                    onChange={(event, value) => this.props.handleDateFormatChange(event.target.name, value)}
                    mask='99.99.9999'
                    style={styles.fontText}
                    errorText={this.props.errors ? this.props.errors.delivered_date : undefined}
                    placeholderMandatory={true}
                  />

                  <DatePicker
                    name='delivered_date'
                    divStyle={{display: 'none'}}
                    locale={this.props.intl.locale}
                    onChange={(event, value) => this.props.handleDateChange(event.target.name, value)}
                    getField={this.handleSetDeliveredDateRef}
                  />

                  {
                    prestation.happened
                      ? <FontIcon
                        onClick={() => this.deliveredDatePicker.focus()}
                        className='material-icons'
                        style={{
                          margin: '20px 5px 0 0',
                          top: !prestation.invoice_only_additional_services ? 348 : 274,
                          right: '78.5%',
                          position: 'absolute',
                          cursor: 'pointer'
                        }}
                      >today
                      </FontIcon>
                      : undefined
                  }
                </div>
              </div>

              {
                !prestation.invoice_only_additional_services
                  ? <div className='row'>
                    <div className='col-md-6 col-xs-12'>
                      <TextField
                        name='delivered_start_time'
                        disabled={!prestation.happened}
                        meta={meta.delivered_start_time}
                        value={deliveredStartTime}
                        floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_START_LABEL)}
                        onChange={(event, value) => this.props.handleTimeFormatChange(event.target.name, value)}
                        mask='99:99'
                        style={styles.fontText}
                        errorText={this.props.errors ? this.props.errors.delivered_start_time : undefined}
                        placeholderMandatory={true}
                      />

                      <TimePicker
                        name='delivered_start_time'
                        divStyle={{display: 'none'}}
                        locale={this.props.intl.locale}
                        onChange={(event, value) => this.props.handleTimeChange(event.target.name, value)}
                        getField={this.handleSetDeliveredStartRef}
                      />

                      {
                        prestation.happened
                          ? <FontIcon
                            onClick={() => this.deliveredStartTimePicker.focus()}
                            className='material-icons'
                            style={{
                              margin: '20px 5px 0 0',
                              top: 417,
                              right: '89%',
                              position: 'absolute',
                              cursor: 'pointer'
                            }}
                          >schedule
                          </FontIcon>
                          : undefined
                      }
                    </div>

                    <div className='col-md-6 col-xs-12'>
                      <TextField
                        name='delivered_end_time'
                        disabled={!prestation.happened}
                        meta={meta.delivered_end_time}
                        value={deliveredEndTime}
                        floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_END_LABEL)}
                        onChange={(event, value) => this.props.handleTimeFormatChange(event.target.name, value)}
                        mask='99:99'
                        style={styles.fontText}
                        errorText={this.props.errors ? this.props.errors.delivered_end_time : undefined}
                        placeholderMandatory={true}
                      />

                      <TimePicker
                        name='delivered_end_time'
                        divStyle={{display: 'none'}}
                        locale={this.props.intl.locale}
                        onChange={(event, value) => this.props.handleTimeChange(event.target.name, value)}
                        getField={this.handleSetDeliveredEndRef}
                      />

                      {
                        prestation.happened
                          ? <FontIcon
                            onClick={() => this.deliveredEndTimePicker.focus()}
                            className='material-icons'
                            style={{
                              margin: '20px 5px 0 0',
                              top: 417,
                              right: '78.5%',
                              position: 'absolute',
                              cursor: 'pointer'
                            }}
                          >schedule
                          </FontIcon>
                          : undefined

                      }
                    </div>
                  </div>
                  : undefined
              }
            </React.Fragment>
            : undefined
        }

        <div className='row'>
          <div className='col-md-6 col-xs-12'>
            <TextField
              meta={meta.additional_services}
              name='additional_services'
              hintText={R.path(['additional_services'], prestation) || '0'}
              value={prestation.additional_services}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_ADDITIONNAL_SERVICES_LABEL)}
              floatingLabelStyle={styles.fontText}
              errorText={this.props.errors ? this.props.errors.additional_services : undefined}
              onChange={this.handleChange}
            />
          </div>
          <div className='col-md-6 col-xs-12'>
            <TextField
              meta={meta.interpreter_delay}
              disabled={!prestation.happened || prestation.invoice_only_additional_services}
              name='interpreter_delay'
              hintText={!prestation.interpreter_delay ? '0' : undefined}
              value={prestation.interpreter_delay}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.STEP_THREE_INTERPRETER_DELAY_LABEL)}
              floatingLabelStyle={styles.fontText}
              errorText={this.props.errors ? this.props.errors.interpreter_delay : undefined}
              onChange={this.handleChange}
            />
          </div>
        </div>

        <div className='row' style={{paddingTop: 15}}>
          <div className='col-md-12 col-xs-12'>
            <Checkbox
              name='invoice_only_additional_services'
              label={this.props.intl.formatMessage(constants.messages.STEP_THREE_INVOICE_ONLY_ADDITIONAL_SERVICES_LABEL)}
              checked={prestation.invoice_only_additional_services}
              style={styles.checkbox}
              onCheck={this.handleInvoiceOnlyAdditionalServicesChange}
            />
          </div>
          <div className='col-md-12 col-xs-12'>
            <Checkbox
              name='happened'
              label={this.props.intl.formatMessage(constants.messages.STEP_THREE_HAPPENED_LABEL)}
              checked={prestation.happened}
              style={styles.checkbox}
              onChange={this.handleChange}
              onCheck={this.handleChangePrestationNotHappened}
            />
          </div>
          <div className='col-md-12 col-xs-12'>
            <Checkbox
              name='interpreter_travelled'
              disabled={
                prestation.invoice_only_additional_services ||
                [constants.PRESTATION_TYPE_PHONE_UID,
                 constants.PRESTATION_TYPE_VIDEO_UID].indexOf(prestation.prestation_type.uid) !== -1
              }
              label={this.props.intl.formatMessage(constants.messages.STEP_THREE_INTERPRETER_TRAVEL_LABEL)}
              checked={prestation.interpreter_travelled}
              style={styles.checkbox}
              onCheck={this.handleChange}
            />
          </div>

          <div className='col-md-12 col-xs-12'>
            <Checkbox
              name='billing'
              label={this.props.intl.formatMessage(constants.messages.STEP_THREE_BILLING_LABEL)}
              checked={prestation.billing}
              style={styles.checkbox}
              onCheck={this.handleBillingChange}
            />
          </div>
        </div>
      </Card>
    )
  }
}

const styles = {
  card: {
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    height: '100%'
  },
  title: {
    textAlign: 'center',
    margin: 0
  },
  checkbox: {
    fontSize: 14,
    paddingTop: 5,
    paddingBototm: 5
  },
  fontText: {
    fontSize: 14
  }
}


export default injectIntl(PrestationValidation)



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/creation/PrestationValidation.js